import { useMaCore } from '@/composables/maCore'
import { queryClient } from '@/api/query-client'
import { useResetPinia } from '../pinia/reset-stores'

export function useClearSession() {
  const { analytics } = useMaCore()
  const resetStore = useResetPinia()

  const clearSession = () => {
    queryClient.clear()
    analytics?.resetUser()
    analytics?.clearIntercomUserInfo()
    resetStore.all()
    sessionStorage.clear()
  }

  return {
    clearSession,
  }
}
